
<div *ngIf="Loader" class="backdrop">
  <div  class="lds-dual-ring"></div>
</div>


